import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Icon } from '@millionshow/client-libs';
import { RouterLink } from '@angular/router';
import { SeoService } from '../../services/seo.service';

@Component({
  selector: 'app-registration-page',
  imports: [CommonModule, Icon, RouterLink],
  templateUrl: './registration.page.html',
})
export default class RegistrationPage {
  private readonly seoService = inject(SeoService);

  constructor() {
    this.seoService.set({
      title: '사전등록 안내',
      description:
        '밀리언쇼 방문객 사전등록 안내를 확인하고 신청 페이지로 이동하세요.',
      path: '/registration',
    });
  }
}
